// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React from 'react';
import cn from 'classnames';
import {Icon} from '../../comp/icon';
import {Text} from '../../comp/text';
import {get_platforms} from './util.js';
import * as cns from './platform_list.module.less';

function Platform({name, logo, compact}){
    return <li className={cn(cns.item, compact&&cns.item__compact)}>
      <Icon ico={logo} size={compact ? 'xxs' : 'm'} tip={compact&&name}/>
      {!compact&&<Text.s>{name}</Text.s>}
    </li>;
}

function Inner({className, offer, compact}){
    const {
        has_android,
        has_ios,
        has_desktop,
    } = get_platforms(offer);
    return <ul className={cn(cns.root, compact&&cns.root__compact, className)}>
      {has_android&&<Platform name="Android" logo="android_logo"
        compact={compact}/>}
      {has_ios&&<Platform name="iOS" compact={compact}
        logo={compact ? 'apple_logo_inline' : 'apple_logo'}/>}
      {has_desktop&&<Platform name="Desktop" logo="desktop_icon_sm"
        compact={compact}/>}
    </ul>;
}

export const Platform_list = React.memo(Inner);
